<template>
  <div>
    <div v-if="tieneAlgunRolCorrespondiente">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
           <span slot="tab">
                <a-icon type="check-square"/>
                Aprobaciones
             </span>
          <g-master name="overtime"
                    @params="paramsTable"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="80%"
                    :actions="master.actions"
                    @action="masterAction"
                    :beforeSend="master.beforeSend"
                    ref="master"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="estadoRenderer" slot-scope="{text}">
              <div>
                <a-tag color="blue">{{text}}</a-tag>
              </div>
            </span>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Empleado')"
                            :formItemConfig="fiOptions"
                            endpoint="empleados"
                            ref="empleado"
                            :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="reader"
                              style="width: 100%"
                              :label="$t('Reader')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_reader', { rules: [{ required: false }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['status', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                              :params="clock_mark_status">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Tipo de Marcación')"
                              :formItemConfig="fiOptions"
                              :decorator="['clock_mark_source', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                              :params="clock_mark_source">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha y Hora de Marcación')">
                    <a-date-picker style="width: 100%"
                                   format="YYYY-MM-DD HH:mm"
                                   show-time
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm"
                                   placeholder="Select Time"
                                   v-decorator="['date_clock_mark', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
        <a-tab-pane key="2">
             <span slot="tab">
                <a-icon type="schedule"/>
               Marcaciones vs programación
             </span>
          <a-collapse accordion>
            <a-collapse-panel key="1" header="Reporteador marcaciones vs programación">
              <a-form-model :model="marcacionesYProgramacion" v-bind="fiOptions" :rules="formRules"
                            ref="form">
                <a-row :gutter="[8,8]">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Empleado')" prop="id_emp" v-bind="fiOptions" has-feedback>
                      <form-model-lookup style="width: 100%"
                                         v-model="marcacionesYProgramacion.id_emp"
                                         endpoint="empleados"
                      >
                      </form-model-lookup>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Año')" prop="year" v-bind="fiOptions">
                      <a-select v-model="marcacionesYProgramacion.year" style="width: 100%">
                        <a-select-option v-for="year_ in years" :key="year_">
                          {{ year_ }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Mes')" prop="month" v-bind="fiOptions">
                      <a-select v-if="!filtroRangoMes" v-model="marcacionesYProgramacion.month" style="width: 80%">
                        <a-select-option v-for="month_ in months_name" :key="month_.value">
                          {{ month_.name }}
                        </a-select-option>
                      </a-select>
                      <a-row v-if="filtroRangoMes" :gutter="[8,8]">
                        <a-col>
                          <a-select v-model="marcacionesYProgramacion.month_initial" style="width: 40%">
                            <a-select-option v-for="month_ in months_name" :key="month_.value">
                              {{ month_.name }}
                            </a-select-option>
                          </a-select>
                          -
                          <a-select v-model="marcacionesYProgramacion.month_end" style="width: 40%">
                            <a-select-option v-for="month_ in months_name" :key="month_.value">
                              {{ month_.name }}
                            </a-select-option>
                          </a-select>
                          <a-tooltip placement="topLeft" title="Modificar filtro de mes">
                            <a-button @click="changeRangoMes" type="primary" icon="retweet"
                                      style="margin-left: 3px; width: 10%"/>
                          </a-tooltip>
                        </a-col>
                      </a-row>
                      <a-tooltip v-if="!filtroRangoMes" placement="topLeft" title="Modificar filtro por rango de mes">
                        <a-button @click="changeRangoMes" type="primary" icon="retweet"
                                  style="margin-left: 3px; width: 10%"/>
                      </a-tooltip>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
              <g-btn-excel :endpoint="endpointExcelMarcaciones" :params="paramsExcelMarcaciones"
                           :fileName="'MarcacionesVsProgramacion'"/>
            </a-collapse-panel>
          </a-collapse>
          <br>
          <g-master name="overtime"
                    :endpoint="masterMarcacinesVsProgramacion.endpoint"
                    :tableSetup="masterMarcacinesVsProgramacion.tableSetup"
                    modalWidth="80%"
                    :actions="masterMarcacinesVsProgramacion.actions"
                    @params="paramsTableMarcacionesVsProgramacion"
                    ref="masterMarcacionesVsProgramacion"
          >
            <span slot="alertaEstadoRenderer" slot-scope="{text}">
              <div v-if="text ==='1'">
                <a-tag style="background-color: #52c41a; border-color: #52c41a">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-tag>
              </div>
              <div v-if="text ==='2'">
                <a-tag style="background-color: orange; border-color: orange">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-tag>
              </div>
              <div v-if="text ==='3'">
                <a-tag style="background-color: yellow; border-color: yellow">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-tag>
              </div>
              <div v-if="text ==='4'">
                <a-tag style="background-color: red; border-color: red">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-tag>
              </div>
            </span>
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcelMarcacionesVsProgramacion"
                           :params="paramsExcelMarcacionesVsProgramacion"
                           :fileName="'MarcacionesVsProgramacion'"/>
            </template>
          </g-master>

        </a-tab-pane>
      </a-tabs>
      <a-modal :title="tituloModal"
               :visible="visibleModal"
               @ok="accionModalOk()"
               :confirmLoading="loadingModal"
               @cancel="accionModalCancel()"
               style="top: 20px;">
        <span>{{mensajeModal}}</span>
        <br/>
        <br/>
        <a-textarea autoSize placeholder="Comentario..." v-model="mensajeAnexo"/>
      </a-modal>
      <a-modal title="Detalle de Marcación"
               :visible="modalDetalleMarcacion"
               :footer="null"
               width="60%"
               :body-style="{ maxHeight: '70vh', overflowY: 'auto' }"
               centered
               @cancel="cerrarModalDetalleMarcacion">
        <div v-if="marcacionSeleccionada">
          <a-tabs defaultActiveKey="1" @change="onTabChange">
            <a-tab-pane key="1">
              <span slot="tab">
                <a-icon type="camera"/>
                Imagen
              </span>
              <div style="text-align: center; min-height: 250px;">
                <a-spin :spinning="loadingImagenMarcacion">
                  <div v-if="imagenMarcacion">
                    <img
                      :src="imagenMarcacion"
                      alt="Imagen de marcación"
                      style="max-width: 100%; max-height: 250px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); object-fit: contain;"
                    />
                  </div>
                  <div v-else-if="!loadingImagenMarcacion" style="padding: 50px;">
                    <a-empty description="No hay imagen disponible para esta marcación">
                      <a-icon type="camera" style="font-size: 48px; color: #ccc;"/>
                    </a-empty>
                  </div>
                </a-spin>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2">
              <span slot="tab">
                <a-icon type="environment"/>
                Ubicación
              </span>
              <div style="min-height: 350px;">
                <a-spin :spinning="loadingMapaMarcacion">
                  <div v-if="coordenadasMarcacion.lat && coordenadasMarcacion.lng">
                    <div
                      style="background: #f0f7ff; border: 1px solid #d6e4ff; border-radius: 6px; padding: 8px; margin-bottom: 8px; font-size: 12px; text-align: center;">
                    <span style="color: #1890ff;">
                      🔍 <strong>Controles de Zoom:</strong>
                      Scroll del mouse • Botones +/- • Doble click • Pellizcar (móvil)
                    </span>
                    </div>
                    <div id="mapaMarcacion"
                         style="height: 300px; width: 100%; border-radius: 8px; border: 1px solid #d9d9d9;"></div>
                    <div style="margin-top: 10px; text-align: center;">
                      <div
                        style="display: flex; justify-content: space-between; align-items: center; background: #fafafa; padding: 8px; border-radius: 4px;">
                        <div>
                          <p style="margin: 0;"><strong>📍 Coordenadas:</strong></p>
                          <p style="margin: 0; font-size: 12px; color: #666;">
                            Lat: {{ coordenadasMarcacion.lat }} | Lng: {{ coordenadasMarcacion.lng }}
                          </p>
                          <p v-if="marcacionSeleccionada.physical_address" style="margin: 8px 0 0 0; font-size: 12px; color: #666;">
                            <strong>Dirección:</strong> {{ marcacionSeleccionada.physical_address }}
                          </p>
                        </div>
                        <div style="font-size: 11px; color: #999;">
                          Click en el marcador para<br>más opciones de navegación
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="!loadingMapaMarcacion" style="padding: 50px; text-align: center;">
                    <a-empty description="No hay coordenadas disponibles para esta marcación">
                      <a-icon type="environment" style="font-size: 48px; color: #ccc;"/>
                    </a-empty>
                  </div>
                </a-spin>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3">
              <span slot="tab">
                <a-icon type="file-text"/>
                Notas
              </span>
              <div style="min-height: 250px; padding: 16px;">
                <p><strong>Observación:</strong> {{ marcacionSeleccionada.observation || 'No hay info disponible' }}</p>
                <p><strong>Comentario:</strong> {{ marcacionSeleccionada.comment || 'No hay info disponible' }}</p>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-modal>
    </div>
    <div v-else>
      <a-result
        status="warning"
        title="Permiso denegado"
        sub-title="A continuación se muestra la razón por la cual no puede acceder a esta pantalla"
      >
        <div class="desc">
          <p style="font-size: 16px;">
            <strong>Situación:</strong>
          </p>
          <p>
            <a-icon :style="{ color: 'red' }" type="close-circle"/>
            Este usuario no cumple con el rol adecuado, por favor contacte a un administrador.
          </p>
        </div>
      </a-result>
    </div>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        now: moment().format('Y-MM-DD HH:mm:ss'),
        clock_mark_status: {
          h_lookup_type: 'ESTADO_CLOCK_MARK',
          use_code: true
        },
        clock_mark_source: {
          h_lookup_type: 'CLOCK_MARK_SOURCE',
          use_code: true
        },
        formRules: {},
        mensajeAnexo: '',
        filtroRangoMes: false,
        months_name: [
          {name: 'Enero', value: 1},
          {name: 'Febrero', value: 2},
          {name: 'Marzo', value: 3},
          {name: 'Abril', value: 4},
          {name: 'Mayo', value: 5},
          {name: 'Junio', value: 6},
          {name: 'Julio', value: 7},
          {name: 'Agosto', value: 8},
          {name: 'Septiembre', value: 9},
          {name: 'Octubre', value: 10},
          {name: 'Noviembre', value: 11},
          {name: 'Diciembre', value: 12}
        ],
        marcacionesYProgramacion: {
          year: parseInt(moment().format('YYYY')),
          month: parseInt(moment().format('MM')),
          month_initial: parseInt(moment().format('MM')),
          month_end: parseInt(moment().format('MM')),
          id_emp: null
        },
        years: [],
        paramsT: {},
        paramsTMarcacionesVsProgramacion: {},
        endpointExcel: 'clock_mark_/downloadExcel',
        endpointExcelMarcaciones: 'marcaciones/downloadExcel',
        endpointExcelMarcacionesVsProgramacion: 'marcaciones_vs_programacion_/downloadExcel',
        fileNameExcel: 'AprobacionTurnos',
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        status: {
          h_lookup_type: 'ESTADO_CONCEPTO_TIEMPO',
          use_code: true
        },
        colSpan: {
          xs: 12,
          md: 8
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        tituloModal: '',
        mensajeModal: '',
        loadingModal: false,
        tipoAccionModal: null,
        visibleModal: false,
        filaSeleccionada: null,
        master: {
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: (record) => {
                return this.$userIsInrol('CreateClockMark')
              }
            },
            {
              name: 'aprobarSolicitudesMasivas',
              text: 'Aprobar solicitudes',
              permisos: [],
              props: {icon: 'check', type: 'primary'},
              fnVisible: () => !this.$userIsInrol('Management') && !this.$userIsInrol('ProgramacionTurno')
            },
            {
              name: 'rechazarSolicitudesMasivas',
              text: 'Rechazar solicitudes',
              permisos: [],
              props: {icon: 'close', type: 'danger'},
              fnVisible: () => !this.$userIsInrol('Management') && !this.$userIsInrol('ProgramacionTurno')
            }
          ],
          endpoint: 'clock_mark',
          tableSetup: {
            allowSelect: true,
            selectType: 'checkbox',
            selectedRowKeys: [],
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'verDetalleMarcacion',
                  text: 'Ver Detalle',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'eye', style: 'color:blue;'},
                  fnVisible: (record) => {
                    return true
                  }
                },
                {
                  name: 'aprobarIndividualmente',
                  text: 'Aprobar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check'},
                  fnVisible: () => !this.$userIsInrol('Management')
                },
                {
                  name: 'rechazarIndividualmente',
                  text: 'Rechazar',
                  permisos: [],
                  props: {size: 'small', icon: 'close', type: 'link', style: {color: 'red'}},
                  fnVisible: () => !this.$userIsInrol('Management')
                },
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return record.clock_mark_source === 'MAN'
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return record.clock_mark_source === 'MAN'
                  }
                }
              ]
            },
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id_clock_mark',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '50', '100', '200'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: '#', dataIndex: 'id_clock_mark', sorter: true},
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Grupo', dataIndex: 'grupo', sorter: true},
              {title: 'Puesto', dataIndex: 'puesto', sorter: true},
              {title: 'Acción realizada', dataIndex: 'reader', sorter: true},
              {title: 'Fecha y hora', dataIndex: 'fecha_hora', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Comentario', dataIndex: 'comments', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        },
        masterMarcacinesVsProgramacion: {
          actions: false,
          endpoint: 'marcaciones_vs_programacion',
          tableSetup: {
            actions: false,
            customSlots: ['alertaEstadoRenderer'],
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '50', '100', '200'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month_desc', sorter: true},
              {title: 'Codigo', dataIndex: 'codigo', sorter: true},
              {title: 'Persona', dataIndex: 'persona', sorter: true},
              {
                title: 'Pro. Inicial',
                dataIndex: 'progini',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {
                title: 'Pro. Final',
                dataIndex: 'progfin',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {title: 'Novedad', dataIndex: 'novedad', sorter: true},
              {
                title: 'Alerta',
                dataIndex: 'alerta',
                sorter: true,
                scopedSlots: {
                  customRender: 'alertaEstadoRenderer'
                }
              },
              {title: 'Turno', dataIndex: 'turno', sorter: true},
              {title: 'Inicio', dataIndex: 'inicio', sorter: true},
              {title: 'Fin', dataIndex: 'fin', sorter: true},
              {title: 'Descripcion', dataIndex: 'descripción', sorter: true},
              {title: 'Creado por', dataIndex: 'progcreated', sorter: true},
              {title: 'Entrada', dataIndex: 'entrada', sorter: true},
              {title: 'Salida', dataIndex: 'salida', sorter: true},
              {title: 'Horas', dataIndex: 'horas', sorter: true},
              {title: 'Horas Diurnas', dataIndex: 'daily_hours', sorter: true},
              {title: 'Horas Nocturnas', dataIndex: 'night_hours', sorter: true},
              {title: 'Hora Real de Entrada', dataIndex: 'horarealentrada', sorter: true},
              {title: 'Hora Real de Salida', dataIndex: 'horarealsalida', sorter: true}
            ]
          }
        },
        modalDetalleMarcacion: false,
        marcacionSeleccionada: null,
        loadingImagenMarcacion: false,
        loadingMapaMarcacion: false,
        imagenMarcacion: null,
        coordenadasMarcacion: {lat: null, lng: null},
        mapaInstancia: null,
        mapaInicializado: false
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
      this.initFormRules()
    },
    methods: {
      changeRangoMes () {
        this.filtroRangoMes = !this.filtroRangoMes
      },
      yearsSelect () {
        for (let i = 2019; i <= (2019 + (parseInt(moment().format('YYYY')) - 2019)); i++) {
          this.years.push(parseInt(i))
        }
      },
      initFormRules () {
        this.formRules = {
          year: [{required: false, message: 'Valor requerido'}],
          month: [{required: false, message: 'Valor requerido'}]
        }
      },
      paramsTable (params) {
        this.paramsT = params
      },
      paramsTableMarcacionesVsProgramacion (params) {
        this.paramsTMarcacionesVsProgramacion = params
      },
      accionModalOk () {
        if (this.tipoAccionModal === 'aprobarIndividual') {
          this.loadingModal = true
          this.filaSeleccionada['accion'] = 'aprobarIndividual'
          this.realizarPeticion(this.filaSeleccionada)
        } else if (this.tipoAccionModal === 'rechazarIndividual') {
          this.loadingModal = true
          this.filaSeleccionada['accion'] = 'rechazarIndividual'
          this.realizarPeticion(this.filaSeleccionada)
        } else if (this.tipoAccionModal === 'aprobarMasivamente') {
          this.loadingModal = true
          this.realizarPeticion({datos: this.master.tableSetup.selectedRows, accion: 'aprobarMasivamente'})
        } else if (this.tipoAccionModal === 'rechazarMasivamente') {
          this.loadingModal = true
          this.realizarPeticion({datos: this.master.tableSetup.selectedRows, accion: 'rechazarMasivamente'})
        }
      },
      realizarPeticion (data) {
        data.comments = this.mensajeAnexo
        this.httpClient.getInstance().post('ejecutar_accion_turno', data).then((response) => {
          Mensajes.success('Correcto', 'Información actualizada correctamente.')
          this.$refs.master.$refs.datatable.loadData()
        }).catch((error) => {
          Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar la información.'))
        }).then(() => {
          this.visibleModal = false
          this.loadingModal = false
        })
      },
      accionModalCancel () {
        this.visibleModal = false
        this.master.tableSetup.allowSelect = true
      },
      masterAction (action) {
        switch (action.action) {
          case 'aprobarIndividualmente':
            this.tituloModal = 'Aprobar turno'
            this.mensajeModal = '¿Desea aprobar este turno?'
            this.tipoAccionModal = 'aprobarIndividual'
            this.mensajeAnexo = ''
            this.visibleModal = true
            this.master.tableSetup.allowSelect = false
            this.filaSeleccionada = action.record
            break
          case 'rechazarIndividualmente':
            this.tituloModal = 'Rechazar turno'
            this.mensajeModal = '¿Desea rechazar este turno?'
            this.tipoAccionModal = 'rechazarIndividual'
            this.mensajeAnexo = ''
            this.visibleModal = true
            this.master.tableSetup.allowSelect = false
            this.filaSeleccionada = action.record
            break
          case 'aprobarSolicitudesMasivas':
            if (JsUtils.isEmpty(this.master.tableSetup.selectedRows)) {
              Mensajes.info('Información', 'No hay turnos seleccionados')
            } else {
              this.tituloModal = 'Aprobar solicitudes masivas'
              this.mensajeModal = '¿Desea aprobar todos los turnos seleccionados?'
              this.tipoAccionModal = 'aprobarMasivamente'
              this.mensajeAnexo = ''
              this.visibleModal = true
            }
            break

          case 'rechazarSolicitudesMasivas':
            if (JsUtils.isEmpty(this.master.tableSetup.selectedRows)) {
              Mensajes.info('Información', 'No hay turnos seleccionados')
            } else {
              this.tituloModal = 'Rechazar solicitudes masivas'
              this.mensajeModal = '¿Desea rechazar todos los turnos seleccionados?'
              this.tipoAccionModal = 'rechazarMasivamente'
              this.mensajeAnexo = ''
              this.visibleModal = true
            }
            break
          case 'verDetalleMarcacion':
            this.marcacionSeleccionada = action.record
            this.abrirModalDetalleMarcacion(this.marcacionSeleccionada)
            break
        }
      },
      onTabChange (activeKey) {
        if (activeKey === '2' && this.coordenadasMarcacion.lat && this.coordenadasMarcacion.lng && !this.mapaInicializado) {
          this.mapaInicializado = true
          setTimeout(() => {
            this.inicializarMapa()
          }, 200)
        }
      },
      cerrarModalDetalleMarcacion () {
        this.modalDetalleMarcacion = false
        this.marcacionSeleccionada = null
        this.imagenMarcacion = null
        this.coordenadasMarcacion = {lat: null, lng: null}
      },
      establecerCoordenadasMarcacion (marcacion) {
        this.loadingMapaMarcacion = true

        if (marcacion.latitude && marcacion.longitude) {
          this.coordenadasMarcacion = {
            lat: parseFloat(marcacion.latitude),
            lng: parseFloat(marcacion.longitude)
          }

          // Ya no inicializamos el mapa automáticamente - esperamos a que el usuario cambie al tab
          setTimeout(() => {
            this.loadingMapaMarcacion = false
          }, 300)
        } else {
          // Si no hay coordenadas en el record, intentar cargar desde el servidor
          this.httpClient.getInstance().get(`ss/dashboard/marcaciones/${marcacion.id_clock_mark}/coordenadas`)
            .then((response) => {
              if (response.data && response.data.latitud && response.data.longitud) {
                this.coordenadasMarcacion = {
                  lat: parseFloat(response.data.latitud),
                  lng: parseFloat(response.data.longitud)
                }

                // Ya no inicializamos el mapa automáticamente - esperamos a que el usuario cambie al tab
              }
            })
            .catch((error) => {
              console.error('Error al cargar coordenadas:', error)
              // No mostramos error ya que es posible que algunas marcaciones no tengan coordenadas
            })
            .then(() => {
              this.loadingMapaMarcacion = false
            })
        }
      },
      async cargarLeaflet () {
        return new Promise((resolve, reject) => {
          if (typeof L !== 'undefined') {
            resolve()
            return
          }

          if (document.getElementById('leaflet-css') || document.getElementById('leaflet-js')) {
            const checkLeaflet = () => {
              if (typeof L !== 'undefined') {
                resolve()
              } else {
                setTimeout(checkLeaflet, 100)
              }
            }
            checkLeaflet()
            return
          }

          const linkCss = document.createElement('link')
          linkCss.id = 'leaflet-css'
          linkCss.rel = 'stylesheet'
          linkCss.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'
          linkCss.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY='
          linkCss.crossOrigin = 'anonymous'
          document.head.appendChild(linkCss)

          const script = document.createElement('script')
          script.id = 'leaflet-js'
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'
          script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo='
          script.crossOrigin = 'anonymous'

          script.onload = () => {
            setTimeout(() => {
              if (typeof L !== 'undefined') {
                resolve()
              } else {
                reject(new Error('Error al cargar Leaflet'))
              }
            }, 100)
          }

          script.onerror = () => {
            reject(new Error('Error al cargar el script de Leaflet'))
          }

          document.head.appendChild(script)
        })
      },
      inicializarMapa (intentos = 0) {
        if (!this.coordenadasMarcacion.lat || !this.coordenadasMarcacion.lng) {
          return
        }

        this.$nextTick(() => {
          setTimeout(() => {
            const mapElement = document.getElementById('mapaMarcacion')
            if (!mapElement) {
              if (intentos < 3) {
                setTimeout(() => this.inicializarMapa(intentos + 1), 500)
                return
              }
              this.mostrarFallbackMapa()
              return
            }

            const rect = mapElement.getBoundingClientRect()
            const computedStyle = window.getComputedStyle(mapElement)

            const isVisible = rect.width > 0 && rect.height > 0 &&
              computedStyle.display !== 'none' &&
              computedStyle.visibility !== 'hidden' &&
              computedStyle.opacity !== '0'

            if (!isVisible) {
              if (intentos < 5) {
                setTimeout(() => this.inicializarMapa(intentos + 1), 800)
                return
              }
              this.mostrarFallbackMapa()
              return
            }

            if (typeof L !== 'undefined') {
              try {
                this.inicializarLeafletMap()
              } catch (error) {
                console.error('Error al ejecutar inicializarLeafletMap:', error)
                this.mostrarFallbackMapa()
              }
            } else {
              this.mostrarFallbackMapa()
            }
          }, 300)
        })
      },
      inicializarLeafletMap () {
        const mapElement = document.getElementById('mapaMarcacion')
        if (!mapElement) {
          this.mostrarFallbackMapa()
          return
        }

        try {
          const lat = parseFloat(this.coordenadasMarcacion.lat)
          const lng = parseFloat(this.coordenadasMarcacion.lng)

          if (isNaN(lat) || isNaN(lng)) {
            throw new Error(`Coordenadas inválidas: lat=${lat}, lng=${lng}`)
          }

          mapElement.innerHTML = ''

          // eslint-disable-next-line no-undef
          this.mapaInstancia = L.map('mapaMarcacion', {
            center: [lat, lng],
            zoom: 16,
            minZoom: 1,
            maxZoom: 20,
            zoomControl: true,
            scrollWheelZoom: true,
            doubleClickZoom: true,
            touchZoom: true,
            zoomSnap: 0.5,
            zoomDelta: 0.5
          })

          // eslint-disable-next-line no-undef
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 20,
            minZoom: 1,
            keepBuffer: 2
          }).addTo(this.mapaInstancia)

          // eslint-disable-next-line no-undef
          const marcadorIcono = L.divIcon({
            className: 'custom-marcador',
            html: '<div style="background-color: #ff4d4f; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>',
            iconSize: [26, 26],
            iconAnchor: [13, 13]
          })

          // eslint-disable-next-line no-undef
          const marker = L.marker([lat, lng], {icon: marcadorIcono})
            .addTo(this.mapaInstancia)
            .bindPopup(`
              <div style="text-align: center; min-width: 200px;">
                <strong>📍 Ubicación de Marcación</strong><br><br>
                <div style="margin: 8px 0;">
                  <strong>Coordenadas:</strong><br>
                  Lat: ${lat}<br>
                  Lng: ${lng}
                </div>
                <div style="margin: 12px 0;">
                  <button onclick="window.open('https://maps.google.com/?q=${lat},${lng}', '_blank')"
                     style="background: #4285f4; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; margin: 2px;">
                    🗺️ Ver en Google Maps
                  </button><br>
                  <button onclick="window.open('https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}&zoom=18', '_blank')"
                     style="background: #7ebc6f; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; margin: 2px;">
                    🌍 Ver en OpenStreetMap
                  </button>
                </div>
                <div style="font-size: 11px; color: #666; margin-top: 8px;">
                  💡 Usa scroll o +/- para hacer zoom<br>
                  Doble click para zoom rápido
                </div>
              </div>
            `)

          marker.openPopup()

          // eslint-disable-next-line no-undef
          L.control.scale({
            metric: true,
            imperial: false,
            position: 'bottomleft'
          }).addTo(this.mapaInstancia)

          setTimeout(() => {
            if (this.mapaInstancia) {
              this.mapaInstancia.invalidateSize()
            }
          }, 100)
        } catch (error) {
          console.error('Error al inicializar mapa con Leaflet:', error)
          this.mostrarFallbackMapa()
        }
      },
      mostrarFallbackMapa () {
        const mapElement = document.getElementById('mapaMarcacion')
        if (!mapElement) {
          return
        }

        mapElement.innerHTML = `
          <div style="background: #f0f0f0; height: 100%; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 8px; min-height: 300px;">
            <div style="text-align: center; padding: 20px;">
              <div style="font-size: 48px; margin-bottom: 15px; color: #1890ff;">📍</div>
              <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">Ubicación de Marcación</div>
              <div style="margin-bottom: 15px; color: #666;">
                <div>Latitud: ${this.coordenadasMarcacion.lat}</div>
                <div>Longitud: ${this.coordenadasMarcacion.lng}</div>
              </div>
              <div style="margin-bottom: 15px;">
                <button onclick="window.open('https://maps.google.com/?q=${this.coordenadasMarcacion.lat},${this.coordenadasMarcacion.lng}', '_blank')"
                   style="color: #1890ff; text-decoration: none; background: #e6f7ff; padding: 8px 16px; border-radius: 4px; border: 1px solid #1890ff; cursor: pointer;">
                  🗺️ Ver en Google Maps
                </button>
              </div>

              <div style="font-size: 12px; color: #999;">
                El mapa interactivo no se pudo cargar
              </div>
            </div>
          </div>
        `
      },
      async abrirModalDetalleMarcacion (marcacion) {
        this.marcacionSeleccionada = marcacion
        this.modalDetalleMarcacion = true
        this.imagenMarcacion = null
        this.coordenadasMarcacion = {lat: null, lng: null}
        this.mapaInicializado = false

        this.cargarImagenMarcacion(marcacion.id_clock_mark)

        if (marcacion.latitude && marcacion.longitude) {
          try {
            await this.cargarLeaflet()
          } catch (error) {
            console.warn('No se pudo cargar Leaflet, usando fallback:', error)
          }
        }

        this.establecerCoordenadasMarcacion(marcacion)
      },
      cargarImagenMarcacion (marcacionId) {
        this.loadingImagenMarcacion = true

        this.httpClient.getInstance().get(`ss/dashboard/marcaciones/${marcacionId}/imagen`, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            if (response.data && response.data.byteLength > 0) {
              let blob = new Blob([response.data], {type: response.headers['content-type'] || 'image/jpeg'})
              this.imagenMarcacion = window.URL.createObjectURL(blob)
            }
          })
          .catch(() => {
            // No mostramos error ya que es normal que algunas marcaciones no tengan imagen
          })
          .then(() => {
            this.loadingImagenMarcacion = false
          })
      }
    },
    computed: {
      tieneAlgunRolCorrespondiente () {
        return this.$userIsInrol('ConfirmaTurno') || this.$userIsInrol('ApruebaTurno') || this.$userIsInrol('AutorizaTurno') || this.$userIsInrol('programaTurno')
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      },
      paramsExcelMarcaciones () {
        return {...this.marcacionesYProgramacion, rango_mes: this.filtroRangoMes}
      },
      paramsExcelMarcacionesVsProgramacion () {
        return {
          ...this.paramsTMarcacionesVsProgramacion,
          columns: this.masterMarcacinesVsProgramacion.tableSetup.columns
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/OvertimeTurn/OvertimeTurn.vue